import { isFirefox } from 'react-device-detect';
import { DragPreview } from 'shared/data_tree/styled';
import { TreeMovableConfig, TreeNode } from 'shared/data_tree/types';
import { useTreeDragDrop } from 'shared/data_tree/useTreeDragDrop';
import { shallow } from 'zustand/shallow';

export type DataTreeDragPreviewProps<TData> = Readonly<{
    node: TreeNode<TData>;
    movable: TreeMovableConfig<TData>;
}>;

export function DataTreeDragPreview<TData>({
    node,
    movable,
}: DataTreeDragPreviewProps<TData>) {
    const { targetNode, previewX, previewY } = useTreeDragDrop(
        (state) => ({
            dragNode: state.dragNode,
            targetNode: state.targetNode,
            previewX: state.previewX,
            previewY: state.previewY,
        }),
        shallow,
    );

    if (isFirefox) {
        return null;
    }

    return (
        <DragPreview
            style={{
                left: previewX + 1,
                top: previewY + 1,
            }}
        >
            {movable.renderPreview({ node, targetNode })}
        </DragPreview>
    );
}
